import { ModifyPasswordSteps } from './profile.types';

export enum ProfileForms {
  accessDataForm,
  sensitiveDataForm,
  domicileForm,
  contactsForm,
  passwordForm,
  phoneForm,
  mailForm,
}

export const emailFieldName = 'mg-n';
export const usernameFieldName = 'un-n';
export const phoneFieldName = 'mb-n';
export const phonePrefixName = 'pr-n';
export const selectSecurityQuestionFieldName = 'sq-n';
export const securityAnswerFieldName = 'na-n';
export const passwordFieldName = 'gm-n';
export const nationFieldName = 'nf-n';
export const municipalityFieldName = 'ci-n';
export const postalCodeFieldName = 'psc-n';
export const addressCodeFieldName = 'ac-n';
export const idDocumentTypeFieldName = 'd-sn';
export const idFrontFieldName = 'dcf-n';
export const idBackFieldName = 'dcb-n';
export const otpCodeFieldName = 'oc-n';

export const usernameAlreadyPresentErrorMessage =
  'error.username.alreadyPresent';

export const mapPayloadKeyToFieldName = {
  username: usernameFieldName,
  password: passwordFieldName,
  newPassword: passwordFieldName,
  country: nationFieldName,
  email: emailFieldName,
  adress: addressCodeFieldName,
};

export const mapAnalyticsNameToFieldName: { [key: string]: string } = {
  [emailFieldName]: 'email',
  [usernameFieldName]: 'username',
  [phoneFieldName]: 'num_telefono',
  [phonePrefixName]: 'prefisso_telefono',
  [selectSecurityQuestionFieldName]: 'domanda_di_sicurezza',
  [securityAnswerFieldName]: 'risposta_sicurezza',
  [passwordFieldName]: 'password',
  [nationFieldName]: 'nazione',
  [municipalityFieldName]: 'comune',
  [postalCodeFieldName]: 'cap',
  [addressCodeFieldName]: 'indirizzo',
  [idDocumentTypeFieldName]: 'documento',
  [idFrontFieldName]: 'documento_fronte',
  [idBackFieldName]: 'documento_retro',
};

export const verifyUsernameEndpoint =
  '/profilo-ms/ms/profile/validate/username';

export const verifyEmailEndpoint = '/profilo-ms/ms/profile/validate/email';

export const verifyContactsEndpoint =
  '/profilo-ms/ms/profile/getContactCertification';

export const modifyPasswordRecovery = 'account-ms/v1/recoveryPassword';

export const modifyPasswordChange = 'account-ms/v1/recoveryPassword/confirm';

export const insertAccountNoteEndpoint =
  'profilo-ms/ms/profile/insertAccountNote';

// Duration in **milliseconds** of the persistance of submssion feedback
// form befores it fades away.
// Does not include the fadein and fadeout.
export const feedbackPersistanceDurationMs = 2_000;

if (!import.meta.env.PROD) {
  if (
    !Number.isSafeInteger(feedbackPersistanceDurationMs) ||
    feedbackPersistanceDurationMs < 1_000
  ) {
    throw new Error(
      `feedbackPersistanceDurationMs dev-only invariant error: expected a value >= 1_000` +
        `1sec, got ${feedbackPersistanceDurationMs} instead.`,
    );
  }
}

export const modifyPasswordModalHeading: Record<ModifyPasswordSteps, string> = {
  0: 'heading.profile.modal.password.change',
  1: 'text.profile.modal.password.change.insertCode',
  2: 'text.profile.modal.password.change.setNewPassword',
  success: 'text.profile.modal.password.change.newPasswordSet',
  error: 'text.profile.modal.password.change.error',
};

export const contactsTypeField = 'contactType';
export const contactsField = 'contacts';
